import { render } from "./CookAttributesComponent.vue?vue&type=template&id=09a05b89&scoped=true"
import script from "./CookAttributesComponent.vue?vue&type=script&lang=js"
export * from "./CookAttributesComponent.vue?vue&type=script&lang=js"

import "./CookAttributesComponent.vue?vue&type=style&index=0&id=09a05b89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a05b89"]])

export default __exports__